import React from 'react';
import Answer from '../../../components/answer/index.js';
import Score from '../../../components/score';
import Breadcrumbs from '../../../components/breadcrumbs';

const Step = (props)=> {
  return (
	<div className="screen">
		<form className="actView fadeIn" onSubmit={props.formHandler}>
			<div className="question">
				<h3 className="header3">02</h3>
				<h5 className="header5">During the <u>past 4 weeks</u>, how often have you had shortness of breath?</h5>
				<div className="columns">
					<div className="column">
						<Answer handler={props.answerHandler} id={props.name+"0"} set={props.name} value="1" state={props.state}>More than once a day</Answer>
						<Answer handler={props.answerHandler} id={props.name+"1"} set={props.name} value="2" state={props.state}>Once a day</Answer>
						<Answer handler={props.answerHandler} id={props.name+"3"} set={props.name} value="3" state={props.state}>3 to 6 times a week</Answer>
					</div>
					<div className="column">
						<Answer handler={props.answerHandler} id={props.name+"4"} set={props.name} value="4" state={props.state}>Once or twice a day</Answer>
						<Answer handler={props.answerHandler} id={props.name+"2"} set={props.name} value="5" state={props.state}>Not at all</Answer>
					</div>
				</div>
			</div>
			<button className="prev" type="button" onClick={props.prevHandler}>Back</button>
			<button className="next" type="submit" disabled>Next</button>
		</form>
		<Score Score={props.TempScore} Results={false} role={props.role} />
		<Breadcrumbs Step={props.step} Steps={props.steps-1} />
	</div>
  );
}

export default Step;
